import { useState } from "react";

import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";

interface Props {
  boardDetails: {
    name: string;
    description: string;
  };
  onSubmit: (feedback: string) => void;
  isSubmitting: boolean;
}

const BoardDetailsReviewStep = ({ boardDetails, onSubmit, isSubmitting }: Props) => {
  const [feedback, setFeedback] = useState("");

  return (
    <Card>
      <CardHeader>
        <CardTitle>Step 1: Review Board Details</CardTitle>
        <CardDescription>
          We've drafted a name and description for your board. Review it and provide feedback if you'd like any changes.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4 p-6 bg-muted rounded-lg">
          <h3 className="text-lg font-semibold">{boardDetails.name}</h3>
          <p className="text-muted-foreground">{boardDetails.description}</p>
        </div>

        <div className="space-y-2">
          <label htmlFor="feedback" className="font-medium">Feedback (Optional)</label>
          <Textarea
            id="feedback"
            placeholder="e.g., 'Make the name more professional', 'The description should mention our target audience of early-stage startups.'"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            disabled={isSubmitting}
          />
        </div>

        <div className="flex justify-end gap-4">
          <Button
            variant="default"
            onClick={() => onSubmit(feedback)}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </>
            ) : feedback ? (
              "Submit Feedback & Continue"
            ) : (
              "Looks Good, Continue"
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default BoardDetailsReviewStep;
